<app-catalog #appCatalog [data]="catalog" [mode]="FormMode.Edit"></app-catalog>

<ng-container *ngIf="{ nameExists: catalogNames | stringInList: catalog.name: oldName } as vars">
  <div style="display: flex; align-items: start; gap: 20px; margin: 20px auto; justify-content: center;">
    <input
      type="button"
      value="Cancel"
      class="cancel"
      (click)="btnCancel_click()"
    />
    <input
      [disabled]="!catalog.name || vars.nameExists || (catalog.name == oldName && catalog.description == oldDescription)"
      type="button"
      value="Save"
      class="primary"
      (click)="btnSave_click()"
    />
  </div>

    @if (vars.nameExists) {
      <div style="color: red; margin-bottom: 10px;">
        This name already exists. Please choose a different name.
      </div>
    }
</ng-container>

<div [hidden]="!this.catalog.id">
  <div style="display: flex; align-items: start; gap: 10px">
    <h2>Items</h2>
    <app-button-input
      [icon]="'PlusAdd'"
      [title]="'Add items'"
      [hidden]="this.mode == FormMode.Edit"
      (click)="btnAddItem_click()"
    ></app-button-input>
  </div>

  <div [hidden]="this.catalog.items?.length == 0">
    @for (item of this.catalog.items; track item.id) {
      <div
        style="
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 5px;
          padding: 5px;
        "
      >
        <app-button-input
          [icon]="'Edit'"
          [title]="'Edit'"
          [hidden]="this.mode == FormMode.Edit"
          (click)="btnEditItem_click(item.id)"
        ></app-button-input>
        <app-button-input
          [icon]="'Trash'"
          [title]="'Delete'"
          [hidden]="this.mode == FormMode.Edit"
          (click)="btnDeleteItem_click(item.id)"
        ></app-button-input>
        <div style="flex: 1; border-bottom: 1px solid #dddddd">
          {{ item.name }} &nbsp;&nbsp;&nbsp;
          <span style="font-size: 12px; color: #444444" [hidden]="!item.price">
            {{
              item.isDiscount
                ? ((item.price ? item.price * -1 : 0) | currency: 'USD')
                : (item.price | currency: 'USD')
            }}
          </span>
          <br />
        </div>
      </div>
    }
  </div>
</div>
